// FILE: client/src/pages/Footer.js

export default function Footer() {
  return (
    <footer style={styles.footer} className="appFooter">
      <div style={styles.brand}></div>

      <div style={styles.links}>
        <a href="/terms" style={styles.link}>Terms</a>
        <span style={styles.dot}>•</span>
        <a href="/privacy" style={styles.link}>Privacy</a>
        <span style={styles.dot}>•</span>
        <a href="/disclaimer" style={styles.link}>Disclaimer</a>
      </div>

      <div style={styles.copy}>
        © 2026 WatchParty Rooms — Private shared moments.
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    marginTop: "16px",
    padding: "20px 16px",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    textAlign: "center",
    fontSize: "14px",
  },
  brand: {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "12px",
    color: "white",
  },
  links: {
    marginBottom: "12px",
  },
  link: {
    color: "#9146ff",
    textDecoration: "none",
    fontWeight: 700,
    opacity: 1,
    WebkitTextFillColor: "#9146ff",
  },
  dot: {
    margin: "0 6px",
    color: "#9146ff",
    opacity: 1,
  },
  copy: {
    fontSize: "12px",
    color: "rgba(255,255,255,0.7)",
  },
};